import copy from "assets/copy.svg";
import pix from "assets/pix.svg";
import { FUMICO_PHONE_NUMBER } from "config";

export const texts = {
  whatsappUrl: `https://api.whatsapp.com/send?phone=${FUMICO_PHONE_NUMBER}&text=`,
  whatsappMessage: "olá! preciso de ajuda para finalizar meu pedido",
};

export const images = {
  copy,
  pix,
};
